import Cookies from 'js-cookie';
import { Button, CircularProgress, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { useLogout } from '../../api/logout';

const AccessDeniedAlert = ({ message }: { message: string }) => {
  const { mutateAsync: logout, isPending } = useLogout();

  const handleReLogin = async () => {
    const r = await logout();
    Cookies.remove('csrftoken', {
      path: '/', domain: window.location.hostname,
    });
    Cookies.remove('csrftoken', {
      path: '/', domain: '.asqq.io',
    });
    Cookies.remove('csrftoken', {
      path: '/', domain: '.user-acquisition.asqq.io',
    });
    if (r.config.baseURL) window.location.href = r.config.baseURL;
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        paddingRight: 2,
        paddingY: 1,
        maxWidth: 340,
      }}
    >
      <Typography
        sx={(t) => ({
          fontSize: t.typography.body2.fontSize,
          wordBreak: 'break-word',
          fontWeight: 500,
        })}
      >
        {message}
      </Typography>
      <Typography sx={(t) => ({ fontSize: t.typography.caption.fontSize })}>
        Please reload the page (Cmd+Shift+R) or try to re-login.
      </Typography>
      <Button
        size="small"
        variant="outlined"
        disabled={isPending}
        startIcon={isPending ? <CircularProgress size={16} color="inherit" /> : undefined}
        sx={{
          alignSelf: 'flex-start',
          color: 'white',
          borderColor: 'white',
          '&:hover': { borderColor: 'white', backgroundColor: 'rgba(255, 255, 255, 0.12)' },
          '&.Mui-disabled': { color: 'rgba(255, 255, 255, 0.6)', borderColor: 'rgba(255, 255, 255, 0.3)' },
        }}
        onClick={() => void handleReLogin()}
      >
        Re-login
      </Button>
    </Box>
  );
};

export default AccessDeniedAlert;
